var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "leo-nl-pack-fade" } }, [
    _vm.visible
      ? _c(
          "div",
          {
            staticClass: "leo-nl-pack-banner",
            class: {
              "is-ready": _vm.phase === "ready",
              "is-progress": _vm.phase === "progress"
            }
          },
          [
            _c(
              "div",
              { staticClass: "leo-nl-pack-orb", class: "phase-" + _vm.phase },
              [
                _c("span", { staticClass: "leo-nl-pack-locale" }, [
                  _vm._v(_vm._s(_vm.localeLabel))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "leo-nl-pack-body" },
              [
                _c("p", { staticClass: "leo-nl-pack-title" }, [
                  _vm._v(_vm._s(_vm.titleText))
                ]),
                _vm._v(" "),
                _vm.subText
                  ? _c("p", { staticClass: "leo-nl-pack-sub" }, [
                      _vm._v(_vm._s(_vm.subText))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.phase === "progress"
                  ? _c("el-progress", {
                      attrs: {
                        percentage: _vm.progressPct,
                        "stroke-width": 4,
                        "show-text": false,
                        status: "success"
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.phase === "prompt"
              ? _c(
                  "div",
                  { staticClass: "leo-nl-pack-actions" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "mini",
                          loading: _vm.busy
                        },
                        on: { click: _vm.onEnable }
                      },
                      [_vm._v("Enable Leo NL")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      { attrs: { size: "mini" }, on: { click: _vm.onLater } },
                      [_vm._v("Later")]
                    )
                  ],
                  1
                )
              : _c(
                  "button",
                  {
                    staticClass: "leo-nl-pack-close",
                    attrs: { type: "button", "aria-label": "Close" },
                    on: { click: _vm.dismiss }
                  },
                  [_vm._v("×")]
                )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-285bfdb3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-285bfdb3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeoNlLocalePackBanner.vue
// module id = null
// module chunks = 